<template>
  <div>
    <label class="cursor-pointer block text-sm">
      <input
        id="checkbox"
        v-model="checked"
        type="checkbox"
        class="mt-4 mr-2"
      />
      {{
        t(
          'subscribeToEventUpdatesModal.firstStep.form.confirmContactCheckbox.label'
        )
      }}
    </label>
    <span
      v-if="!isConfirmed"
      data-test-id="date-request-form-invalid"
      class="text-red text-sm block"
    >
      {{ t('general.form.validation.required') }}
    </span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  isConfirmed: boolean
}

const { isConfirmed } = defineProps<Props>()

const checked = defineModel<boolean>({ required: true })

const { t } = useI18n()
</script>
